import { Skeleton } from '@/components/ui/skeleton';
import { TableCell, TableRow } from '@/components/ui/table';

export default () => {
  return [...new Array(8)].map((_, index) => {
    return (
      <TableRow className="border-borderColor hover:!bg-[unset] h-[72px]" key={index}>
        <TableCell className="pl-0">
          <Skeleton className="h-[42px] w-full rounded-xl" />
        </TableCell>
        <TableCell>
          <Skeleton className="h-[42px] w-full rounded-xl" />
        </TableCell>
        <TableCell className="pr-0">
          <Skeleton className="h-[42px] w-full rounded-xl" />
        </TableCell>
      </TableRow>
    );
  });
};
